import { connect } from 'react-redux';
import KomentarManual from '../../../views/Kurikulum/Ulangan/KomentarManual.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(KomentarManual);
